<template>
  <div class="all_part">
    <div class="logo">
      <img src="../assets/main_menu_Phone/Logo.png" alt="" />
    </div>
    <div class="main_button">
      <div
        class="button"
        @click="Second_jiage"
        v-if="user_leave.standardType == 1"
      >
        <img src="../assets/Main_menu_img/JiaGeKuCun.png" alt="" width="40pt" />
        <span>价格与库存</span>
      </div>
      <div
          class="button"
          @click="FinancePhone"
          v-if="user_leave.financeType == 1"
      >
        <img src="../assets/Main_menu_img/YingShouKuanYuFaPiao.png" alt="" />
        <span>应收款与发票</span>
      </div>
      <div class="button" @click="NeiBuXieTiao" v-if="user_leave.task == 1">
        <img src="../assets/Main_menu_img/NeiBuXieTiao.png" alt="" />
        <span>内部协调</span>
      </div>
      <div
        class="button"
        @click="Second_ZhuDang"
        v-if="user_leave.master_gear == 1"
      >
        <img src="../assets/Main_menu_img/ICChanPinXinXi.png" alt="" />
        <span>IC产品信息</span>
      </div>
      <div
        class="button"
        @click="TableInputPhone"
        v-if="user_leave.competitive_products == 1"
      >
        <img src="../assets/Main_menu_img/ICShiChangXinXi.png" alt="" />
        <span> IC市场情报</span>
      </div>
      <div
        class="button"
        @click="OrderPhone"
        v-if="user_leave.orderType == 1"
      >
        <img src="../assets/Main_menu_img/newOrder.png" alt="" />
        <span> 订单中心</span>
      </div>
      <div
        class="button"
        @click="MessagePhone"
      >
        <img src="../assets/Main_menu_img/message.png" alt="" />
        <span> 消息通知</span>
      </div>
      <div class="buttons" ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Main_menuPhone",
  data() {
    return {
      user_leave: {},
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    MessagePhone() {
      this.$router.push("/NewsPhone");
    },
    getUser() {
      this.user_leave = JSON.parse(sessionStorage.getItem("user"));
      console.log(this.user_leave);
    },
    JingPinDengJi() {
      this.$router.push("/Main_menuPhone_JingPingDengJi");
    },   Second_jiage() {
      this.$router.push("/Main_menuPhone_JiaGeYuKuCun");
    },
    Second_ZhuDang() {
      this.$router.push("/ICChanPinXinXi_phone");
    },
    TableInputPhone() {
      this.$router.push("/CompetitionRegistration_phone");
    },
    OrderPhone() {
      this.$router.push("/OrderPlone");
    },
    NeiBuXieTiao() {
      this.$router.push("/missionPhone");
    },

    FinancePhone() {
      this.$router.push("/FinancePhone");
    },
  },
};
</script>

<style>
</style>
<style scoped>
.all_part {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-image: url("../assets/Login_img_phone/bg1.png");
}
.main_button {
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
}
.logo {
  background-image: url("../assets/main_menu_Phone/bg@3x.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 142pt;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo img {
  margin-top: 18px;
}
.JiaGeKuCun {
  width: 100%;
  margin-top: 20px;
  align-items: center;
  justify-content: space-around;
  display: flex;
  flex-direction: row;
}
.button {
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 105pt;
  width: 105pt;
  background-color: #409eff;
  border-radius: 6px;
}
.buttons {
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 105pt;
  width: 105pt;
  background-color: none;
  border-radius: 6px;
}
.left_button {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
}
.button img {
  width: 40pt;
  height: 40.5pt;
  display: flex;
}
.button span {
  font-weight: 500;
  color: #ffffff;
  font-size: 16pt;
  margin-top: 12px;
}
.TwoButton {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>